import { defineStore } from 'pinia'

interface FeatureState {
  features: Set<string>
  tenant: null | { id: number; name: string; domain: string }
  loading: boolean
}

export const useFeatureStore = defineStore('features', {
  state: (): FeatureState => ({
    features: new Set<string>(),
    tenant: null,
    loading: false,
  }),
  getters: {
    hasFeature: state => (name: string) => state.features.has(name),
    all: state => Array.from(state.features),
  },
  actions: {
    async load() {
      if (this.loading)
        return
      this.loading = true
      try {
        const tenantId = localStorage.getItem('tenantId')
        const headers: Record<string, string> = { Accept: 'application/json' }

        if (tenantId)
          headers['X-Tenant-ID'] = tenantId

        const data = await $api<any>('/features', { headers })

        this.features = new Set<string>(Array.isArray(data.features) ? data.features : [])
        this.tenant = data.tenant ?? null
      }
      finally {
        this.loading = false
      }
    },
    async save(nextFeatures: string[]) {
      this.loading = true
      try {
        const tenantId = localStorage.getItem('tenantId')

        const headers: Record<string, string> = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }

        if (tenantId)
          headers['X-Tenant-ID'] = tenantId

        const data = await $api<any>('/features', {
          method: 'PUT',
          headers,
          body: { features: nextFeatures },
        })

        this.features = new Set<string>(Array.isArray(data.features) ? data.features : [])
        this.tenant = data.tenant ?? null
      }
      finally {
        this.loading = false
      }
    },
  },
})
